module.exports = __webpack_public_path__ + "static/media/471ed56b-545f-4608-a050-9c01ce3995dd.925056b3.JPG";